import axios from "axios";
import { getBackendUrl } from "api/common";

interface AppData {
  authUrl: string;
  clientId: string;
  userPoolId: string;
}

export const getAppData = async (): Promise<AppData> => {
  const response = await axios.get<AppData>(`${getBackendUrl()}/app-data`);
  return response.data;
};
